module.exports = __webpack_public_path__ + "img/bird-5-right.ac75f289.png";